import React from 'react'

import { CoinStore } from './stores/CoinStore'
import { AlertStore } from './stores/AlertStore'
import { DrawingState } from './stores/DrawingState'

import Charts from './components/Charts'
import CoinPicker from './components/CoinPicker'
import IntervalPicker from './components/IntervalPicker'
import Alerts from './components/Alerts'
import Settings from './components/Settings'
import WatchList from './components/WatchList'
import TradeCalculator from './components/TradeCalculator'

export default class App extends React.Component {
  state = {
    loaded: false,
    showWatchList: false,
    showCoinPicker: false,
    showIntervalPicker: false,
    showAlerts: false,
    showCalculator: false,
    showSettings: false,
    showAbout: false,
    trendlineEnabled: false,
    layout: [], // a list of currency pairs, eg ['BTC_XRP']
    interval: 900, // default to 15m
  }

  componentDidMount() {
    var initalState = {}
    
    var layout = localStorage.getItem('layout')
    if (layout) {
      initalState.layout = JSON.parse(layout)
    }

    var interval = localStorage.getItem('interval')
    if (interval) {
      initalState.interval = Number(interval)
    }

    if (window.location.hash === '#alerts') {
      initalState.showAlerts = true
    } else if (window.location.hash === '#currencies') {
      initalState.showCoinPicker = true
    } else if (window.location.hash === '#watchlist') {
      initalState.showWatchList = true
    } else if (window.location.hash === '#calculator') {
      initalState.showCalculator = true
    } else if (window.location.hash === '#about') {
      initalState.showAbout = true
    }

    if (CoinStore.loaded) {
      initalState.loaded = true
    } else {
      // wait for data to load
      CoinStore.on('init', () => {
        this.setState({ loaded: true })
      })
      CoinStore.init()
    }

    this.setState(initalState)
  }

  nav = () => {
    if (this.state.showWatchList || this.state.showCalculator) return

    if (this.state.showAlerts) {
      return (<nav className="w-100">
        <div className='pa2'>
          <Alerts onExit={() => this.setState({ showAlerts: false })} />
        </div>
      </nav>)
    }

    return (<nav className="w-100">
      <div className="pa2 overflow-x-auto">
        <a className='f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr3'
          href="#currencies"
          onClick={() => this.setState({ showCoinPicker: true })}>
          Currencies
        </a>
        <a className='f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr3'
          href="#alerts"
          onClick={() => this.setState({ showAlerts: true })}>
          Alerts
        </a>
        <a className='f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr3'
          href="#watchlist"
          onClick={() => this.setState({ showWatchList: true })}>
          Watchlist
        </a>
        <a className='f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr3'
          href="#calculator"
          onClick={() => this.setState({ showCalculator: true })}>
          Calculator
        </a>
        <a className='f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr3'
          href="#interval"
          onClick={() => this.setState({ showIntervalPicker: true })}>
          { IntervalPicker.secondsToInterval(this.state.interval) }
        </a>
        { this.trendlineNavItem() }
        <a className='f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr3'
          href="#settings"
          onClick={() => this.setState({ showSettings: true })}>
          Settings
        </a>
        <a className='f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr3'
          href="#about"
          onClick={() => this.setState({ showAbout: true })}>
          ?
        </a>
      </div>
    </nav>)
  }

  trendlineNavItem = () => {
    var classes = 'f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr3'
    if (this.state.trendlineEnabled) classes += ' active'
    return (
      <a className={classes} href="#charts" onClick={this.toggleTrendline}>
        Trendline
      </a>
    )
  }

  onCoinPick = (symbol, id) => {
    var layout = this.state.layout;
    layout[id - 1] = symbol; // id starts at 1
    this.setState({showCoinPicker: false, layout: layout})
    localStorage.setItem('layout', JSON.stringify(layout))
    // console.log('will plot ' + symbol + ' in window ' + id)
  }

  closeCoinChart = (symbol) => {
    var layout = this.state.layout.filter(s => {
      return s !== symbol
    })
    this.setState({layout})
    localStorage.setItem('layout', JSON.stringify(layout))
  }

  onIntervalSet = (interval) => {
    localStorage.setItem('interval', interval)
    this.setState({showIntervalPicker: false, interval: interval})
  }

  toggleTrendline = () => {
    DrawingState.toggleTrendline()
    this.setState({trendlineEnabled: DrawingState.trendlineEnabled()})
  }

  render () {
    if (!this.state.loaded) {
      return (
        <p className='pl2'>Loading...</p>
      )
    }

    return (
      <div className="mw-100 center">
        { this.nav() }

        {this.state.showCoinPicker &&
          <CoinPicker
            onCancel={() => this.setState({showCoinPicker: false})}
            onSelect={this.onCoinPick}
          />
        }

        {this.state.showIntervalPicker &&
          <IntervalPicker
            onCancel={() => this.setState({showIntervalPicker: false})}
            onSelect={this.onIntervalSet}
          />
        }

        {this.state.showSettings &&
          <Settings
            onCancel={() => this.setState({showSettings: false})} />
        }

        { this.state.showWatchList &&
          <WatchList
            onCancel={() => this.setState({showWatchList: false})}
          />
        }

        { this.state.showCalculator &&
          <TradeCalculator
            onCancel={() => this.setState({showCalculator: false})}
          />
        }

        { this.renderAbout() }

        { this.renderCharts() }
      </div>
    )
  }

  renderCharts = () => {
    if (this.state.showCalculator || this.state.showWatchList) return

    return <Charts
            layout={this.state.layout}
            interval={this.state.interval}
            onChartClose={this.closeCoinChart}
            onChartClick={(symbol, event) => {
              if (this.state.showAlerts) {
                event.symbol = symbol
                AlertStore.emit('set-alert', event)
              }
          }} />
  }

  renderAbout = () => {
    if (this.state.showAbout) {
      return (
        <div className='absolute settings z-index-100 shadow-2'>
          <div className='w-100'>
            <button className='bg-animate'
              onClick={() => this.setState({showAbout: false})}>Close</button>
          </div>
          <div className='w-100 pa3'>
            <b>Where do you get the data?</b><br/>
            From <a href="https://poloniex.com/support/api/">Poloniex</a>.
            <small>&nbsp;You should not run this app in multiple tabs due to Poloniex API request limit.</small>
            <br/><br/>
            <b>What did you use to make this app?</b><br/>
            ReactJS, <a href="https://github.com/rrag/react-stockcharts">React Stockcharts</a>, D3.
            <br/><br/>
            <b>Disclaimer</b><br/>
            This app is provided "as is" with no warranty of any kind, express or implied.
          </div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.js